<template>
  <v-container fluid>
    <div>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-top-transition">
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar color="red" dark>
              Status
              <v-spacer> </v-spacer>
              <v-card-actions>
                <v-btn text @click="dialog.value = false">Close</v-btn>
              </v-card-actions>
            </v-toolbar>
            <v-alert
              v-if="successCount > 0"
              text
              type="success"
            >
              {{successCount}} Fee Plan <strong>successfully uploaded.</strong>
            </v-alert>

            <template>
              <v-simple-table>
                <template>
                  <thead>
                    <tr>
                      <th class="text-xs-right">status</th>
                      <th class="text-xs-right">
                        Plan Name
                      </th>
                      <th>
                        Plan Applicable to
                      </th>
                      <th>
                        Franchisee
                      </th>
                      <th>Class</th>
                      <th>Fee Type Name</th>
                      <!-- <th>Installment Details</th> -->
                      <!-- <th>Installment Details</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in failure" :key="item.id">
                      <td>{{ item.status }}</td>
                      <td class="text-xs-right">{{ item.feePlanName }}</td>
                      <td>{{ item.planApplicableTo }}</td>
                      <td>
                        <div v-for="int0 in item.franchisee" :key="int0.id">
                          {{ int0 }}
                        </div>
                      </td>
                      <td>
                        {{ item.class }}
                      </td>
                      <td>
                        <div v-for="int0 in item.feeTypeMap" :key="int0.id">
                          {{ int0.feeTypeName }}
                        </div>
                      </td>
                      <!-- <td>
                        <div v-for="int0 in item.feeTypeMap" :key="int0.id">
                          <div v-for="int1 in int0.installments" :key="int1.id">
                            Installement Name: {{ int1.name }} <br />Amount: {{ int1.amount }} <br />Start Date: {{ new Date(int1.startDate).toLocaleDateString() }}<br />
                            End Date: {{ new Date(int1.endDate).toLocaleDateString() }}<br />Due Date: {{ new Date(int1.dueDate).toLocaleDateString() }}
                          </div>
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
          </v-card>
        </template>
      </v-dialog>
    </div>
    <material-card icon="mdi-clipboard-text" inline title="Upload Fee Component">
      <v-card-actions>
        <router-link :to="{ name: 'FeePlanList' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <form @submit.prevent="saveCSV(dropFiles, true)" enctype="multipart/form-data" name="SaveWowKitMapping">
        <v-card flat class="px-2">
          <template>
            <v-row>
              <v-col cols="12" md="6" lg="4">
                <drop-down type="forCurrentYear"></drop-down>
              </v-col>
            </v-row>
          </template>
        </v-card>
        <v-card-component>
          <v-row>
            <v-col cols="12">
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title three-line>Instructions:</v-list-item-title>
                  <v-list-item-subtitle class="mt-2"><span class="font-weight-bold my-2 error--text">*</span> The Number of columns/Fields in the csv file should be 11.</v-list-item-subtitle>
                  <v-list-item-subtitle
                    ><span class="font-weight-bold my-2 error--text">*</span> All fields are mandatory. mandatory fields must be uploaded otherwise gives the Error Message and file will not allow to
                    upload</v-list-item-subtitle
                  >
                  <v-list-item-subtitle> Example: Franchisee, Plan_Name, No_Of_Installments_In_Fee_Plan, Applicable_To, Class, FeeTypeName, Installment_Name, Amount, Due_Date(DD/MM/YYYY), Start_Date(DD/MM/YYYY), End_Date(DD/MM/YYYY), isCompulsory </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span class="font-weight-bold my-2 error--text ">*</span> Correct format- Corporate, TEST PLAN, NEW, TODDLER, Admission Fees, Installment 1, 1000, 10/01/2020, 10/01/2020, 31/03/2021, TRUE
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="my-2 error--text">Note: CSV Fields Can't be with commas ,Since It won't support the lines and throws the errors...</v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-2"><span class="font-weight-bold my-2 error--text">*</span> Single File upload at a time </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="6" lg="4" class="text-right">
              <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top color="primary" href="https://stagecdn.brainbees.com/education/totsweb/stage/portal19/upload-fee-plan/Student_Fee_Plan_Dummy.csv"
                ><v-icon medium left>mdi-download</v-icon> Download dummy file</v-btn
              >
              <v-btn color="primary" absolute v-else right top fab small elevation="1"> <v-icon>mdi-download</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-col cols="12" md="6">
            <v-file-input
              label="Click to upload"
              class="my-0 py-1"
              clear-icon="mdi-close"
              placeholder="Please do upload .csv file only"
              v-model="dropFiles"
              accept=".csv"
            ></v-file-input>
          </v-col>
          <v-col cols="12" class="text-left">
            <v-btn color="primary" elevation="1" type="submit"><v-icon left>mdi-content-save</v-icon>Upload</v-btn>
          </v-col>
        </v-card-component>
      </form>
    </material-card>
  </v-container>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import store from '@/store'
import _ from 'lodash'
import DropDown from '../../reusableComp/dropDown'
export default {
  name: 'UploadFeeComponent',
  components: {
    DropDown,
    VCardComponent,
    MaterialCard
  },
  data () {
    return {
      changeTitle: '',
      selectedClass: '',
      isError: false,
      alert: false,
      dropFiles: [],
      feeType: [],
      total: 0,
      paginated: false,
      perPage: 10,
      loadingComponent: null,
      fileinput: '',
      isResponse: false,
      franchiseeArr: [],
      classes: [],
      componentArray: [],
      failure: [],
      dialog: false,
      successCount: 0
    }
  },
  created: function () {
    // this.onStart()
  },
  watch: {
    dialog: function (value) {
      console.log('value---', value)
    }
  },
  computed: {
    academicYearID: {
      get () {
        return store.state.feeComponent.academicYearID
      },
      set (value) {
        store.commit('updateAcadmicYrId', value)
      }
    },
    categoryID: {
      get () {
        return store.state.feeComponent.categoryID
      },
      set (value) {
        store.commit('updatecategoryID', value)
      }
    }
  },
  methods: {
    deleteDropFile (index) {
      this.isResponse = false
      this.dropFiles.splice(index, 1)
    },
    saveCSV: async function (file, KEY) {
      try {
        if (!file) {
          return this.$dialog.error({
            text: 'Please Upload File',
            title: 'Error'
          })
        }
        if (_.isArray(file)) {
          if (file.length === 0) {
            return this.$dialog.error({
              text: 'Please Upload File',
              title: 'Error'
            })
          }
        }
        let formData = new FormData()
        formData.append('academicYearID', this.academicYearID)
        formData.append('feeComponentFile', file)
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.post(`${constants.API_URL}/api/fee-component-upload`, formData)
        this.successCount = data.count.success
        let failurData = _.filter(data.response, (d) => {
          return _.has(d, 'status')
        })

        if (Number(data.count.failure) > 0) {
          this.changeTitle = false
          this.failure = failurData
          this.dialog = true
        }
        if (Number(data.count.failure) === 0) {
          this.$router.push({
            name: 'FeePlanList'
          })
          this.$buefy.dialog.alert({
            type: 'is-success',
            message: `${data.count.success} Fee Plan Uploaded successfully`,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.loadingComponent.close()
      }
    }
  }
}
</script>
